import React, { useState } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import Email from "@material-ui/icons/Email";
import People from "@material-ui/icons/People";
// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";
import CustomInput from "components/CustomInput/CustomInput.js";

import styles from "assets/jss/material-kit-react/views/formPage.js";

import image from "assets/img/background.jpeg";
import logo from "assets/img/logo-512.png";
import mail from "assets/img/gif/mail-download.gif";

const config = require("data/siteConfig");

const useStyles = makeStyles(styles);

export default function ThanksPage(props) {
  const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
  setTimeout(function () {
    setCardAnimation("");
  }, 700);
  const classes = useStyles();
  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRoundedCircle,
    classes.imgFluid,
    classes.divider
  );
  const { ...rest } = props;
  return (
    <div>
      <Header
        absolute
        color="transparent"
        brand={config.siteName}
        rightLinks={<HeaderLinks />}
        {...rest}
      />
      <div
        className={classes.pageHeader}
        style={{
          backgroundImage: "url(" + image + ")",
          backgroundSize: "cover",
          backgroundPosition: "top center",
        }}
      >
        <div className={classes.container}>
          <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={8}>
              <Card className={classes[cardAnimaton]}>
                  <CardHeader color="primary" className={classes.cardHeader}>
                    <h4>Contact Us</h4>
                    <div className={classes.socialLine}>
                      <Button
                        justIcon
                        href="https://twitter.com/x200labs"
                        target="_blank"
                        color="transparent"
                        onClick={() => {
                          window.open("https://twitter.com/x200labs", "_blank");
                        }}
                      >
                        <i className={"fab fa-twitter"} />
                      </Button>
                      <Button
                        justIcon
                        href="https://www.facebook.com/x200labs"
                        target="_blank"
                        color="transparent"
                        onClick={() => {
                          window.open("https://www.facebook.com/x200labs", "_blank");
                        }}
                      >
                        <i className={"fab fa-facebook"} />
                      </Button>
                      <Button
                        justIcon
                        href="https://www.instagram.com/x200labs"
                        target="_blank"
                        color="transparent"
                        onClick={() => {
                          window.open("https://www.instagram.com/x200labs", "_blank");
                        }}
                      >
                        <i className={"fab fa-google"} />
                      </Button>
                    </div>
                  </CardHeader>
                  <CardBody>
                    <img src={mail} alt="..."
                      className={imageClasses}
                      width={"150px"}
                      height={"150px"}
                      style={{backgroundColor: "black", borderRadius: "50%", margin: "auto", padding: "10px", display: "block"}}
                    />
                    <h3 className={classes.divider}>Your message was sent!</h3>
                    <h4 className={classes.divider}>Thanks for reaching out. We will be in contact shortly.</h4>
                  </CardBody>
                  <CardFooter className={classes.cardFooter}>

                  </CardFooter>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
        <Footer whiteFont />
      </div>
    </div>
  );
}
